import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep2_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F40.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame40() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);


        return (
            <div className="F40_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F40_entryBox">
                    <div className="F40_paragraph">
                        {language === 'english' ?
                            <p className="F40_paragraphEnglish">Saira recalls her friend Maria found it awkward to change sanitary pad in school and had instead skipped school. Saira does not want to skip school and fall behind in studies. She also finds it embarrassing to change the sanitary pad in school.</p>
                            :
                            <p className="F40_paragraphUrdu">سائرہ یہ سوچ رہی ہے کہ ماریہ کو اسکول میں پیڈ تبدیل کرنے میں ہچکچاہٹ محسوس ہوتی تھی۔ اور اسی لئے وہ اسکول سے غیر حاضر رہنے کو ترجیح دیتی تھی۔ لیکن سائرہ اسکول سے چھٹی نہیں کرنا چاہتی پر وہ بھی اسکول میں پیڈ تبدیل کرنے سے ہچکچا رہی ہے۔</p>
                        }
                    </div>

                    <div className="F40_timeline">
                        <div className='F40_timelineBar'>
                            <div className='F40_timelineFill'></div>
                            <span className='F40_timelineText'>13/19</span>
                        </div>
                    </div>

                    <div className="F40_nextFrames">
                        <div className="F40_nextFrame1"></div>
                        <div className="F40_nextFrame2"></div>
                        <div className="F40_nextFrame3"></div>
                    </div>

                    <div className='F40_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep2_lastVisitFrame(13)) }} className='F40_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
}

export default Frame40;